<template>
  <div class="kt-portlet kt-portlet--height-fluid">
    <div
      class="kt-portlet__head kt-portlet__head kt-portlet__head--lg kt-portlet__head--noborder kt-portlet__head--break-sm"
    >
      <div class="kt-portlet__head-label">
        <span class="kt-portlet__head-icon">
          <i class="fal fa-video"></i>
        </span>
        <h3 class="kt-portlet__head-title">Recent Videos</h3>
      </div>
    </div>
    <div class="kt-portlet__body">
      <v-data-table
        :headers="headers"
        :items="videos"
        sort-by="name"
        class="elevation-1"
        :server-items-length="total"
        :loading="isFetching"
        :items-per-page="5"
        @update:page="changePage"
        @update:sort-by="updateSorting"
        @update:sort-desc="updateSorting"
        :options.sync="options"
      >
        <template v-slot:top>
          <v-toolbar flat color="white" max-height="20">
            <v-dialog v-model="videoForm" max-width="500px" scrollable>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <form class="kt-form">
                      <div class="form-group">
                        <label>Video Type</label>

                        <div class="d-flex w-100">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <label
                                class="radio col-6"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <input
                                  v-model="editedItem.type"
                                  type="radio"
                                  id="video-day"
                                  value="1"
                                  name="radio-group"
                                  checked
                                />
                                <span></span>
                                Video of the day
                              </label>
                            </template>
                            <span>Daily new videos to help your team grow</span>
                          </v-tooltip>

                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <label
                                class="radio col-6"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <input
                                  v-model="editedItem.type"
                                  type="radio"
                                  id="featured"
                                  value="2"
                                  name="radio-group"
                                  checked
                                />
                                <span></span>
                                Featured
                              </label>
                            </template>
                            <span
                              >Video that will constantly appear on your site
                              until it reaches its expiration date or you change
                              it manually</span
                            >
                          </v-tooltip>
                        </div>
                      </div>
                      <div class="form-group">
                        <label>Name</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Title of the Video"
                          v-model="editedItem.name"
                          required
                          v-validate="'required'"
                          name="name"
                        />
                        <span class="kt-font-danger validate-error">
                          {{ errors.first('name') }}
                        </span>
                      </div>
                      <div class="form-group">
                        <v-switch
                          v-model="editedItem.fileUploadOrLink"
                          label="Video Upload"
                        ></v-switch>
                      </div>
                      <div
                        class="form-group"
                        v-if="!editedItem.fileUploadOrLink"
                      >
                        <label>Video URL</label>
                        <input
                          @input="fetchVideoId"
                          type="text"
                          class="form-control"
                          placeholder="Enter Video URL"
                          v-model="editedItem.videoUrl"
                          required
                          v-validate="'required|url'"
                          name="url"
                        />
                        <span
                          class="kt-font-danger validate-error"
                          v-show="errors.has('url')"
                        >
                          {{ errors.first('url') }}
                        </span>
                      </div>
                      <div
                        class="form-group"
                        v-if="editedItem.fileUploadOrLink"
                      >
                        <label
                          >Current video:
                          <a :href="editedItem.videoUrl">View Upload</a></label
                        >
                        <v-file-input
                          v-model="editedItem.videoFile"
                          v-validate="'required'"
                          accept="video/*"
                        >
                        </v-file-input>
                        <span
                          class="kt-font-danger validate-error"
                          v-show="errors.has('image')"
                          >{{ errors.first('image') }}</span
                        >
                      </div>
                      <div class="form-group">
                        <label>Start Date and Time</label>
                        <flat-pickr
                          :config="configs.dateTimePicker"
                          id="datetime-input"
                          class="form-control"
                          v-model="editedItem.startDate"
                          placeholder="Date Time"
                          v-validate="'required'"
                          data-vv-name="startDate"
                        />
                        <span class="kt-font-danger validate-error">
                          {{ errors.first('start_at') }}
                        </span>
                      </div>
                      <div
                        class="form-group"
                        v-if="
                          (editedItem.expiration == false &&
                            editedItem.type == 2) ||
                          editedItem.type == 1
                        "
                      >
                        <label>End Date and Time</label>
                        <flat-pickr
                          :config="configs.dateTimePicker"
                          id="datetime-input"
                          class="form-control"
                          v-model="editedItem.endDate"
                          placeholder="Date Time"
                          v-validate="'required'"
                          data-vv-name="endDate"
                        />

                        <span class="kt-font-danger validate-error">
                          {{ errors.first('end_at') }}
                        </span>
                      </div>
                      <div class="form-group" v-if="editedItem.type == '2'">
                        <v-checkbox
                          v-model="editedItem.expiration"
                          label="No Expiry"
                          color="indigo"
                          hide-details
                        ></v-checkbox>
                      </div>
                      <div class="kt-form__actions text-center">
                        <v-btn
                          color="blue darken-2"
                          dark
                          :loading="isLoading"
                          @click="save"
                        >
                          Save
                        </v-btn>
                        &nbsp;
                        <v-btn color="grey lighten-1" dark @click="close">
                          Close
                        </v-btn>
                      </div>
                    </form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.end_at="{ item }">
          <span v-if="item.end_at">{{ item.end_at | displayDateTime }}</span>
          <span v-else>No end date</span>
        </template>
        <template v-slot:item.start_at="{ item }">
          <span v-if="item.start_at">{{
            item.start_at | displayDateTime
          }}</span>
          <span v-else>No start date</span>
        </template>
        <template v-slot:item.type="{ item }">
          <span>{{ item.type == 2 ? 'Featured Video' : 'VOTD' }}</span>
        </template>
        <template v-slot:item.url="{ item }">
          <v-btn
            class="btn btn-label-info btn-sm btn-icon"
            @click="openVideo(item.url)"
          >
            <i class="fas fa-play"></i>
          </v-btn>
        </template>
        <template
          v-if="isCurrentUserSuperAdmin || isCurrentUserManager"
          v-slot:item.action="{ item }"
        >
          <button
            type="button"
            class="btn btn-label-info btn-sm btn-icon"
            @click="editItem(item)"
          >
            <i class="fal fa-edit" />
          </button>
          &nbsp;
          <button
            class="btn btn-label-dark btn-sm btn-icon"
            @click="deleteItem(item)"
          >
            <i class="far fa-trash" />
          </button>
        </template>
        <template v-slot:no-data>
          <v-btn
            class="primaryMainText--text"
            color="primaryMain"
            @click="initialize"
            >Reset</v-btn
          >
        </template>
      </v-data-table>
    </div>

    <date-picker
      :dialog="datePickerDialog"
      :datePickerType="datePickerType"
      :toggleDatePickerDialog="toggleDatePickerDialog"
      :saveDatePicker="saveDatePicker"
      :startDate="editedItem.startDate"
      :endDate="editedItem.endDate"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { forEach as _forEach, head as _head, map as _map } from 'lodash-es';
import EventBus from '../../plugins/eventBus';

import DatePicker from '../dashboard/DatePicker.vue';
import { some as _some, debounce as _debounce } from 'lodash-es';

export default {
  name: 'VideoTable',
  components: { DatePicker },
  data() {
    return {
      isSearchingUnits: false,
      isFetching: false,
      videoForm: false,
      headers: [],
      editedIndex: -1,
      editedItem: {
        id: '',
        name: '',
        videoUrl: '',
        startDate: null,
        expiration: true,
        endDate: null,
        relatedUnits: [],
        type: '1',
        fileUploadOrLink: false,
        videoFile: [],
      },
      relatedUnits: [],
      defaultItem: {
        title: '',
        videoUrl: '',
        start_at: '',
        end_at: '',
        expiration: true,
        type: '1',
        fileUploadOrLink: false,
        videoFile: [],
      },
      isLoading: false,
      current_page: 1,
      source: '',
      selectedRelatedUnits: [],
      datePickerType: '',
      datePickerDialog: false,
      options: {
        groupBy: [],
        groupDesc: [],
        itemsPerPage: 10,
        multiSort: false,
        mustSort: false,
        page: 1,
        sortBy: ['start_at'],
        sortDesc: [true],
        isFilteredByRecentDays: true,
      },

      debounce: null,
      youtube_id: null,
      videoType: 0, // 0 = VIMEO 1 = YOUTUBE,

      configs: {
        dateTimePicker: {
          enableTime: true,
          dateFormat: 'm/d/Y G:i K',
        },
      },

      flatPickrVideoDateFormat: 'M/DD/YYYY h:mm a',
      savingVideoDateFormat: 'YYYY-MM-DD HH:mm:ss',
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New' : 'Edit';
    },
    videos() {
      return this.$store.state.videosDaily.videos;
    },
    total() {
      return this.$store.state.videosDaily.total
        ? this.$store.state.videosDaily.total
        : 0;
    },
    roles() {
      return this.$auth.user().roles;
    },
    isCurrentUserSuperAdmin() {
      return _some(this.roles, { name: 'super-administrator' });
    },
    isCurrentUserManager() {
      return (
        _some(this.roles, { name: 'account-manager' }) ||
        _some(this.roles, { name: 'specific-dealer-manager' })
      );
    },
  },

  watch: {
    videoForm(val) {
      this.$validator.reset();
      // eslint-disable-next-line no-unused-expressions
      val || this.close();
    },
  },

  mounted() {
    this.$validator.localize('en', {
      attributes: {
        name: 'name',
        videoUrl: 'video url',
      },
    });
    EventBus.$on('refreshVideoTable', () => {
      this.initialize();
    });
  },

  created() {
    this.initialize();
    this.initializeHeaders();
  },

  methods: {
    openVideo(url) {
      window.open(url);
    },
    initializeHeaders() {
      let headers = [
        {
          text: 'Actions',
          align: 'center',
          value: 'action',
          width: 150,
        },
        {
          text: 'Title',
          sortable: true,
          align: 'left',
          value: 'title',
          width: 200,
        },
        {
          text: 'Replay ',
          align: 'center',
          value: 'url',
          sortable: true,
          width: 300,
        },
        {
          text: 'Start Date',
          sortable: true,
          align: 'center',
          value: 'start_at',
          width: 200,
        },
        {
          text: 'End Date',
          sortable: true,
          align: 'center',
          value: 'end_at',
          width: 200,
        },
        {
          text: 'Type',
          sortable: true,
          align: 'center',
          value: 'type',
          width: 200,
        },
      ];

      if (
        _some(this.roles, { name: 'salesperson' }) ||
        _some(this.roles, { name: 'account-manager' })
      ) {
        headers.splice(0, 0);
      }

      this.headers = headers;
    },
    youtubeParser(url) {
      const regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      const match = url.match(regExp);
      const youtubeId = match && match[7].length == 11 ? match[7] : false;

      return youtubeId;
    },
    fetchVideoId() {
      if (this.debounce != null) {
        this.debounce.cancel;
      }

      this.debounce = _debounce(function () {
        this.validateVideoURL();
      }, 250);

      this.debounce();
    },
    validateVideoURL() {
      this.loading = true;

      let youtubeId = this.youtubeParser(this.editedItem.videoUrl);

      if (this.editedItem.videoUrl.includes('vimeo') || youtubeId != false) {
        if (youtubeId != false) {
          this.youtube_id = youtubeId;
          this.videoType = 1;
        } else {
          this.youtube_id = this.getIdFromVimeoURL(this.editedItem.videoUrl);
          this.videoType = 0;
        }
      } else {
        this.$notify('warning', 'Not a Vimeo URL or YouTube URL ');
        this.editedItem.videoUrl = '';
        this.youtube_id = '';
      }
      this.loading = false;

      return;
    },
    changePage(page) {
      this.current_page = page;
      this.initialize();
    },
    updateSorting() {
      this.current_page = 1;
      this.initialize();
    },
    saveDatePicker(val) {
      if (this.datePickerType === 'startDate') {
        return (this.editedItem.startDate = dayjs(val));
      }

      return (this.editedItem.endDate = dayjs(val));
    },
    toggleDatePickerDialog() {
      this.datePickerDialog = !this.datePickerDialog;
    },
    openDatePicker(type) {
      this.toggleDatePickerDialog();
      this.datePickerType = type;
    },

    getUnits(search) {
      this.isSearchingUnits = true;
      if (this.source) {
        this.source.cancel();
      }
      this.source = this.axios.CancelToken.source();
      try {
        this.axios
          .get(`featured-video/related-units`, {
            params: {
              search,
            },
            cancelToken: this.source.token,
          })
          .then(({ data }) => {
            this.relatedUnits = data;
            this.isSearchingUnits = false;
          })
          .catch((error) => {
            this.isSearchingUnits = false;
          });
      } catch (e) {
        this.relatedUnits = this.selectedRelatedUnits;
        this.isSearchingUnits = false;
      }
    },
    initialize() {
      this.isFetching = true;
      this.axios
        .get('/featured-videos', {
          params: {
            page: this.current_page,
            sortBy: this.options.sortBy[0],
            sortDesc: this.options.sortDesc[0],
            isFilteredByRecentDays: this.options.isFilteredByRecentDays,
          },
        })
        .then(({ data }) => {
          this.$store.dispatch('videosDaily/setList', data);
        })
        .finally(() => {
          this.isFetching = false;
        });
    },
    assignItem(item) {
      this.editedItem.id = item.id;
      this.editedItem.name = item.title;
      this.editedItem.videoUrl = item.url;
      this.editedItem.endDate = item.end_at
        ? dayjs(item.end_at).format(this.flatPickrVideoDateFormat)
        : null;
      this.editedItem.expiration = item.expiration;
      this.editedItem.startDate = item.start_at
        ? dayjs(item.start_at).format(this.flatPickrVideoDateFormat)
        : null;
      this.selectedRelatedUnits = item.related_units;
      this.relatedUnits = this.selectedRelatedUnits;
      this.editedItem.relatedUnits = item.related_units;
      this.editedItem.fileUploadOrLink = item.is_video;
      this.editedItem.type = item.type.toString();
    },
    editItem(item) {
      this.videoForm = true;
      this.assignItem(this.videos[this.videos.indexOf(item)]);
    },
    deleteItem(item) {
      const index = this.videos.indexOf(item);
      this.$swal({
        title: 'Are you sure?',
        text: "You can't revert this action.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it.',
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch('videosDaily/deleteVideo', this.videos[index].id)
            .then(() => {
              this.$store.commit('videosDaily/removeVideo', index);
              this.$notify('success', 'Video removed successfully!');
              this.initialize();
            })
            .catch((error) => console.log(error));
        }
      });
    },
    close() {
      this.videoForm = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      this.isLoading = true;
      this.$validator
        .validate('*')
        .then((result) => {
          if (result) {
            return this.send();
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getIdFromVimeoURL(url) {
      let videoURL =
        /(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/([a-z]*\/)*([0-9]{6,11})\?h=([a-zA-Z0-9]*)[?]?.*/.exec(
          url
        );

      if (videoURL == null) {
        videoURL =
          /(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/([a-z]*\/)*([0-9]{6,11})\/?([a-zA-Z0-9]*)[?]?.*/.exec(
            url
          );
      }

      if (videoURL[6]) {
        return videoURL[5] + '?h=' + videoURL[6];
      }

      return videoURL[5];
    },
    setFormData() {
      const { relatedUnits } = this.editedItem;
      const formData = new FormData();
      formData.append('id', this.editedItem.id);
      formData.append('name', this.editedItem.name);
      formData.append('videoUrl', this.youtube_id);
      formData.append('videoType', this.videoType);
      formData.append(
        'startDate',
        dayjs(this.editedItem.startDate).format(this.savingDateFormat)
      );
      formData.append(
        'endDate',
        this.editedItem.type == 2
          ? this.editedItem.expiration
            ? null
            : dayjs(this.editedItem.endDate).format(this.savingDateFormat)
          : dayjs(this.editedItem.endDate).format(this.savingDateFormat)
      );
      formData.append(
        'relatedUnits',
        _map(relatedUnits, (unit) => {
          return unit.id;
        })
      );
      formData.append(
        'expiration',
        this.editedItem.type == 2 ? this.editedItem.expiration : false
      );
      formData.append('type', this.editedItem.type);
      formData.append('fileUploadOrLink', this.editedItem.fileUploadOrLink);
      formData.append('videoFile', this.editedItem.videoFile);
      formData.append('_method', 'patch');

      return formData;
    },

    send() {
      this.isLoading = true;

      this.axios
        .post(`/featured-videos/${this.editedItem.id}`, this.setFormData(), {
          headers: {
            'Content-type': 'multipart/form-data',
          },
        })
        .then(() => {
          this.initialize();
          this.$notify('success', 'Daily video updated!');
          this.close();
        })
        .catch((errors) => {
          this.interactWithErrorBag((errors, this.errors));
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    printRelatedUnits(units) {
      let unitsTitle = '';
      if (Array.isArray(units)) {
        let unitsLength = units.length;
        while (unitsLength--) {
          unitsLength === 0
            ? (unitsTitle += units[unitsLength].name)
            : (unitsTitle += units[unitsLength].name + ', ');
        }
      }
      return unitsTitle;
    },
  },
};
</script>
<style lang="stylus">
.v-btn--icon.v-size--default .v-icon, .v-btn--fab.v-size--default .v-icon
  font-size 14px

.v-data-table td
  font-size 12px

.validate-error
   font-size 12px

 .v-data-footer__select
   display none
</style>
